var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAdd = function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 8H1a.97.97 0 0 1-.712-.287A.97.97 0 0 1 0 7q0-.424.288-.713A.97.97 0 0 1 1 6h5V1q0-.424.287-.712A.97.97 0 0 1 7 0q.424 0 .713.288Q8 .575 8 1v5h5q.424 0 .713.287Q14 6.576 14 7q0 .424-.287.713A.97.97 0 0 1 13 8H8v5q0 .424-.287.713A.97.97 0 0 1 7 14a.97.97 0 0 1-.713-.287A.97.97 0 0 1 6 13z"
  })));
};
export default SvgIconAdd;